import { createAsyncThunk } from "@reduxjs/toolkit";

import {
    ReasonedOrdersResponse,
    GetROParams,
    GenerateRORequest,
    UpsertRORequest,
    LegacyReasonedOrderAPI,
    ReasonedOrderAPI,
} from "../../../../../api/reasonedOrder";

import { MessageResponse } from "../../../../../api/common";


export const fetchLegacyReasonedOrdersThunk = createAsyncThunk<
    ReasonedOrdersResponse,
    { case_id: string } & GetROParams,
    { rejectValue: string }
>(
    'reports/fetchLegacyReasonedOrders',
    async (params, { rejectWithValue }) => {
        try {
            return await LegacyReasonedOrderAPI.get_reasoned_orders(params);
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch Reasoned Order reports');
        }
    }
);

export const fetchSinglePartyLegacyROReportThunk= createAsyncThunk<
    ReasonedOrdersResponse,
    { case_id: string, report_id: string,party_id: string},
    { rejectValue: string }
>(
    'reports/fetchSinglePartyLegacyRO',
    async ({ case_id, report_id }, { rejectWithValue }) => {
        try {
            return await LegacyReasonedOrderAPI.get_reasoned_orders({ case_id, report_id });
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to fetch Reasoned Order report for Party');
        }
    }
);


export const createLegacyReasonedOrderThunk = createAsyncThunk<
    MessageResponse,
    { case_id: string; request: GenerateRORequest },
    { rejectValue: string }
>(
    'reports/createLegacyReasonedOrder',
    async ({ case_id, request }, { rejectWithValue }) => {
        try {
            return await LegacyReasonedOrderAPI.create_reasoned_order(case_id, request);
        } catch (error: any) {
            return rejectWithValue(error.message || 'Generate Reasoned Order report submission failed');
        }
    }
);

export const upsertLegacyReasonedOrderThunk = createAsyncThunk<
    MessageResponse,
    { case_id: string; report_id: string; request: UpsertRORequest },
    { rejectValue: string }
>(
    'reports/upsertLegacyReasonedOrder',
    async ({ case_id, report_id, request }, { rejectWithValue }) => {
        try {
            return await LegacyReasonedOrderAPI.upsert_reasoned_order(case_id, report_id, request);
        } catch (error: any) {
            return rejectWithValue(error.message || 'Failed to update Reasoned Order report');
        }
    }
);

export const fetchReasonedOrdersThunk = createAsyncThunk<
    ReasonedOrdersResponse,
    { case_id: string } & GetROParams,
    { rejectValue: string }
>(
    "reports/fetchReasonedOrders",
    async (params, { rejectWithValue }) => {
        try {
            return await ReasonedOrderAPI.get_ro_reports(params);
        } catch (error: any) {
            return rejectWithValue(
                error.message || "Failed to fetch Reasoned Order reports"
            );
        }
    }
);


export const createReasonedOrderThunk = createAsyncThunk<
    MessageResponse,
    { case_id: string; request: GenerateRORequest },
    { rejectValue: string }
>(
    "reports/createReasonedOrder",
    async ({ case_id, request }, { rejectWithValue }) => {
        try {
            return await ReasonedOrderAPI.generate_ro_report(
                case_id,
                request
            );
        } catch (error: any) {
            return rejectWithValue(
                error.message ||
                    "Generate Reasoned Order report submission failed"
            );
        }
    }
);

export const fetchSinglePartyROReportThunk = createAsyncThunk<
    ReasonedOrdersResponse,
    { case_id: string; report_id: string, party_id: string},
    { rejectValue: string }
>(
    "reports/fetchSinglePartyRO",
    async ({ case_id, report_id }, { rejectWithValue }) => {
        try {
            return await ReasonedOrderAPI.get_ro_reports({
                case_id,
                report_id,
            });
        } catch (error: any) {
            return rejectWithValue(
                error.message ||
                    "Failed to fetch Reasoned Order report for Party"
            );
        }
    }
);

export const upsertReasonedOrderThunk = createAsyncThunk<
    MessageResponse,
    {
        case_id: string;
        report_id: string;
        request: UpsertRORequest;
    },
    { rejectValue: string }
>(
    "reports/upsertReasonedOrder",
    async ({ case_id, report_id, request }, { rejectWithValue }) => {
        try {
            return await ReasonedOrderAPI.upsert_ro_report(
                case_id,
                report_id,
                request
            );
        } catch (error: any) {
            return rejectWithValue(
                error.message || "Failed to update Reasoned Order report"
            );
        }
    }
);



